import { Okta, Jumpcloud } from '@/assets/icons/sso';
import { RipplingIcon } from '@/assets/icons/HRIS';
import { Key01 } from '@kula-ai/icons/dual-tone/Key01';

export const iconMappings = [
  {
    integration_type: 'okta',
    icon: Okta,
  },
  {
    integration_type: 'rippling/rippling_api',
    icon: RipplingIcon,
  },
  {
    integration_type: 'jump_cloud',
    icon: Jumpcloud,
  },
  {
    integration_type: 'custom',
    icon: Key01,
  },
];
